import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { num: "01", title: "Share Your Vision", desc: "Send us your product link or website. We analyze your brand's unique DNA." },
  { num: "02", title: "Strategic Scripting", desc: "Our creative team crafts a high-converting script optimized for your goal." },
  { num: "03", title: "AI Generation", desc: "We deploy state-of-the-art AI systems to render your professional video assets." },
  { num: "04", title: "Refined Revisions", desc: "We polish the details to ensure every frame aligns with your brand standards." },
  { num: "05", title: "Rapid Delivery", desc: "Receive your ready-to-use marketing assets within 24 to 72 hours." }
];

const VideoProcess = () => {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-emerald-600 font-black text-sm uppercase tracking-[0.2em] mb-4">Workflow</h2>
          <p className="text-4xl md:text-5xl font-extrabold text-slate-900">How We Deliver Excellence</p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-slate-100 -translate-y-1/2 z-0" />
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 relative z-10">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-8 rounded-[2rem] border border-slate-100 shadow-sm text-center"
              >
                <div className="text-emerald-500 font-black text-4xl mb-6">{step.num}</div>
                <h3 className="text-xl font-bold text-slate-900 mb-4">{step.title}</h3>
                <p className="text-slate-500 text-sm font-medium leading-relaxed">{step.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoProcess;
